import React, { FC } from 'react'

// Constants
import { useFlag } from 'constants/flags'

// Components
import SignUpFormOld, {
  Fields,
  Submit,
  Errors,
  SignUpFormProps as SignUpFormPropsOld,
} from './SignUpForm.old'
import SignUpForm, { SignUpFormProps } from './SignUpForm'

const SignUpFormSwitch: FC<SignUpFormPropsOld | SignUpFormProps> = props => {
  // TODO: Remove usages of 'onboarding-licenses-signup' feature flag
  // https://github.com/sketch-hq/Cloud/issues/10012
  const isOnboardingLicensesSignupEnabled = useFlag(
    'onboarding-licenses-signup'
  )

  return isOnboardingLicensesSignupEnabled ? (
    <SignUpForm {...props} />
  ) : (
    <SignUpFormOld {...props} />
  )
}

export default Object.assign(SignUpFormSwitch, {
  Fields,
  Submit,
  Errors,
})
